import React from 'react';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import _adviserPortalHome from './_adviserPortalHome';
import { withTranslation } from 'react-i18next';
import '../css/AdviserPortalCharts.css';

function ContributorsGraph(props) {
    const { t } = props;
    let chart = am4core.create('contributorsChart', am4charts.PieChart);
    const total_Contributing_Details = _adviserPortalHome._contributorsAndNonContributors(_adviserPortalHome._adviserDahsboardBodyInDetail(props));
    chart.logo.setVisibility(false);

    //Add data
    chart.data = [
        {
            "type": "Non Contributors",
            "members": total_Contributing_Details.nonContributors,
            "color": "#51820F"
        }, {
            "type": "Contributors",
            "members": total_Contributing_Details.contributors,
            "color": "#304E09"
        },]

    const pieSeries = chart.series.push(new am4charts.PieSeries())
    pieSeries.dataFields.value = "members";
    pieSeries.dataFields.category = "type";
    pieSeries.slices.template.propertyFields.fill = "color";

    // pieSeries.alignLabels = false;
    // pieSeries.labels.template.bent = true;
    // Let's cut a hole in our Pie chart the size of 40% the radius
    chart.innerRadius = am4core.percent(70);
    chart.radius = am4core.percent(100)
    pieSeries.ticks.template.disabled = true;
    pieSeries.alignLabels = false;
    pieSeries.labels.template.disabled = true;
    // pieSeries.labels.template.text = "{value.percent.formatNumber('#.0')}%";
    // Put a thick white border around each Slice
    pieSeries.slices.template.stroke = am4core.color("#FFFFFF");
    pieSeries.slices.template.strokeWidth = 2;
    pieSeries.slices.template.strokeOpacity = 1;

    //Lables inside the Donut chart
    var label = pieSeries.createChild(am4core.Label);
    var totalMembers = total_Contributing_Details.contributors + total_Contributing_Details.nonContributors;
    var contributorsPercentage = total_Contributing_Details.contributors / totalMembers * 100;
    label.text = Math.round(contributorsPercentage) + "%";
    label.horizontalCenter = "middle";
    label.verticalCenter = "middle";
    label.fontSize = "24pt";
    label.fill = am4core.color("#3d4d5c")

    // Add a legend
    chart.legend = new am4charts.Legend();
    chart.legend.valueLabels.template.disabled = true; //Do not display the values for legends.
    chart.legend.markers.template.height = 10;
    chart.legend.markers.template.width = 10;
    chart.legend.labels.template.fill = am4core.color("#3d4d5c");
    chart.legend.margin(30, 0, 0, 0)


    // chart.legend.height = 150;
    // chart.legend.width = 300;
    return (
        <div style={{ textAlign: "center" }}>
            <div className="contributorsChartTitle">{t('Graphs:contributorsGraphTitle')}</div>
            <div id="contributorsChart"></div>
        </div>
    )
}

export default withTranslation()(ContributorsGraph);